import { mixins } from '@sy/component-library';

const { mediaQueries } = mixins;

export const RELATED_POSTS_GRID_GAP = 24;

export const RELATED_POSTS_MAX_WIDTH = 969;

export const RELATED_POSTS_VIEWPORT_WIDTH = 100;

export const RELATED_POSTS_VERTICAL_PADDING = 24;

export const POSTS_PER_ROW_BELOW_MEDIUM = 1;
export const POSTS_PER_ROW_BELOW_LARGE = 2;
export const POSTS_PER_ROW_ABOVE_LARGE = 3;

const MAX_LARGE_IMAGE_WIDTH = Math.ceil(
	(RELATED_POSTS_MAX_WIDTH -
		(POSTS_PER_ROW_ABOVE_LARGE - 1) * RELATED_POSTS_GRID_GAP) /
		POSTS_PER_ROW_ABOVE_LARGE,
);

export const REDUCED_BLOG_POST_IMAGE_SIZES = `${mediaQueries.belowMedium} ${
	RELATED_POSTS_VIEWPORT_WIDTH / POSTS_PER_ROW_BELOW_MEDIUM
}vw, ${mediaQueries.belowLarge} ${
	RELATED_POSTS_VIEWPORT_WIDTH / POSTS_PER_ROW_BELOW_LARGE
}vw, ${mediaQueries.belowXLarge} ${
	RELATED_POSTS_VIEWPORT_WIDTH / POSTS_PER_ROW_ABOVE_LARGE
}vw, ${MAX_LARGE_IMAGE_WIDTH}px`;
